export const podcasts = [
  {
    id: "1",
    title: "The Tech Talk Daily",
    publisher: "Tech Media Network",
    description: "Your daily dose of technology news, insights, and interviews with industry leaders. Covering everything from AI and machine learning to cybersecurity and emerging tech trends.",
    image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=400&h=400&fit=crop",
    category: "Technology",
    totalEpisodes: 245,
    language: "English",
    rating: 4.8,
    subscribers: 125000,
    episodes: [
      {
        id: "1-1",
        title: "The Future of AI in Healthcare",
        description: "Join us as we explore how artificial intelligence is revolutionizing healthcare, from diagnostic tools to personalized treatment plans.",
        duration: "45:30",
        publishDate: "2024-11-20",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "1-2",
        title: "Cybersecurity Best Practices for 2024",
        description: "Expert tips and strategies to keep your data safe in an increasingly connected world.",
        duration: "38:15",
        publishDate: "2024-11-19",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "1-3",
        title: "The Rise of Quantum Computing",
        description: "Understanding quantum computing and its potential to transform computing as we know it.",
        duration: "52:00",
        publishDate: "2024-11-18",
        audio: "https://example.com/episode3.mp3"
      },
      {
        id: "1-4",
        title: "Web3 and the Decentralized Internet",
        description: "Exploring the future of the internet with blockchain technology and decentralization.",
        duration: "41:20",
        publishDate: "2024-11-17",
        audio: "https://example.com/episode4.mp3"
      },
      {
        id: "1-5",
        title: "Building Sustainable Tech Products",
        description: "How companies are creating eco-friendly technology solutions for a better tomorrow.",
        duration: "36:45",
        publishDate: "2024-11-16",
        audio: "https://example.com/episode5.mp3"
      }
    ]
  },
  {
    id: "2",
    title: "Business Builders Podcast",
    publisher: "Entrepreneur Media",
    description: "Learn from successful entrepreneurs and business leaders about building, scaling, and growing businesses from the ground up.",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=400&fit=crop",
    category: "Business",
    totalEpisodes: 189,
    language: "English",
    rating: 4.7,
    subscribers: 98000,
    episodes: [
      {
        id: "2-1",
        title: "From Startup to Scale-Up",
        description: "Proven strategies for taking your startup to the next level with guest Sarah Chen, CEO of TechVentures.",
        duration: "50:15",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "2-2",
        title: "Marketing on a Bootstrap Budget",
        description: "Creative marketing tactics that don't break the bank for early-stage companies.",
        duration: "43:30",
        publishDate: "2024-11-18",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "2-3",
        title: "The Art of Raising Capital",
        description: "Venture capitalists share what they look for in potential investments.",
        duration: "55:00",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode3.mp3"
      },
      {
        id: "2-4",
        title: "Building High-Performance Teams",
        description: "Leadership insights on hiring, managing, and retaining top talent.",
        duration: "47:20",
        publishDate: "2024-11-12",
        audio: "https://example.com/episode4.mp3"
      }
    ]
  },
  {
    id: "3",
    title: "True Crime Chronicles",
    publisher: "Crime Podcast Network",
    description: "Deep dives into the most fascinating true crime cases, with expert analysis and investigative reporting.",
    image: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=400&h=400&fit=crop",
    category: "True Crime",
    totalEpisodes: 156,
    language: "English",
    rating: 4.9,
    subscribers: 210000,
    episodes: [
      {
        id: "3-1",
        title: "The Vanishing of Emma Roberts - Part 1",
        description: "A mysterious disappearance that baffled investigators for over a decade.",
        duration: "58:45",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "3-2",
        title: "The Vanishing of Emma Roberts - Part 2",
        description: "New evidence comes to light in this gripping conclusion.",
        duration: "61:15",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "3-3",
        title: "The Art Heist of the Century",
        description: "How thieves pulled off one of the most daring museum robberies in history.",
        duration: "52:30",
        publishDate: "2024-11-08",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "4",
    title: "Mind & Body Wellness",
    publisher: "Healthy Living Media",
    description: "Expert advice on mental health, fitness, nutrition, and overall wellness to help you live your best life.",
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=400&fit=crop",
    category: "Health & Fitness",
    totalEpisodes: 312,
    language: "English",
    rating: 4.6,
    subscribers: 87000,
    episodes: [
      {
        id: "4-1",
        title: "Mindfulness in Modern Life",
        description: "Practical meditation techniques for busy professionals with renowned mindfulness coach Dr. James Liu.",
        duration: "35:20",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "4-2",
        title: "Nutrition Myths Debunked",
        description: "Separating fact from fiction with registered dietitian Maria Rodriguez.",
        duration: "42:00",
        publishDate: "2024-11-20",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "4-3",
        title: "Sleep Science: Getting Quality Rest",
        description: "Understanding the science of sleep and how to improve your sleep quality.",
        duration: "39:45",
        publishDate: "2024-11-17",
        audio: "https://example.com/episode3.mp3"
      },
      {
        id: "4-4",
        title: "Strength Training for Beginners",
        description: "Everything you need to know to start your fitness journey safely and effectively.",
        duration: "44:30",
        publishDate: "2024-11-14",
        audio: "https://example.com/episode4.mp3"
      },
      {
        id: "4-5",
        title: "Managing Stress and Anxiety",
        description: "Evidence-based strategies for coping with stress in daily life.",
        duration: "40:15",
        publishDate: "2024-11-11",
        audio: "https://example.com/episode5.mp3"
      }
    ]
  },
  {
    id: "5",
    title: "Comedy Hour Live",
    publisher: "Laugh Factory Studios",
    description: "Stand-up comedians and comedy writers share hilarious stories, industry insights, and perform live sets.",
    image: "https://images.unsplash.com/photo-1585699324551-f6c309eedeca?w=400&h=400&fit=crop",
    category: "Comedy",
    totalEpisodes: 278,
    language: "English",
    rating: 4.5,
    subscribers: 156000,
    episodes: [
      {
        id: "5-1",
        title: "Life on the Road with Mike Stevens",
        description: "Comedian Mike Stevens shares wild stories from touring comedy clubs across America.",
        duration: "62:30",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "5-2",
        title: "Writing Room Stories",
        description: "TV comedy writers reveal what really happens behind the scenes.",
        duration: "48:15",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "5-3",
        title: "Open Mic Disasters and Triumphs",
        description: "Comedians share their most memorable open mic experiences.",
        duration: "55:00",
        publishDate: "2024-11-08",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "6",
    title: "History Untold",
    publisher: "Historical Society Media",
    description: "Uncover fascinating stories from history that you never learned in school, told by expert historians.",
    image: "https://images.unsplash.com/photo-1461360370896-922624d12aa1?w=400&h=400&fit=crop",
    category: "History",
    totalEpisodes: 134,
    language: "English",
    rating: 4.8,
    subscribers: 92000,
    episodes: [
      {
        id: "6-1",
        title: "The Lost City of Atlantis: Fact or Fiction?",
        description: "Archaeological evidence and ancient texts examined by leading historians.",
        duration: "51:20",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "6-2",
        title: "Women Spies of World War II",
        description: "The untold stories of female espionage agents who changed the course of history.",
        duration: "46:45",
        publishDate: "2024-11-14",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "6-3",
        title: "The Silk Road: Ancient Trade Routes",
        description: "How the Silk Road connected civilizations and transformed the world.",
        duration: "49:30",
        publishDate: "2024-11-07",
        audio: "https://example.com/episode3.mp3"
      },
      {
        id: "6-4",
        title: "Viking Explorers in North America",
        description: "Evidence of Viking settlements centuries before Columbus.",
        duration: "53:15",
        publishDate: "2024-10-31",
        audio: "https://example.com/episode4.mp3"
      }
    ]
  },
  {
    id: "7",
    title: "Sports Talk Unlimited",
    publisher: "Sports Network Podcasts",
    description: "Breaking down the biggest stories in sports with expert analysis, player interviews, and fan debates.",
    image: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=400&h=400&fit=crop",
    category: "Sports",
    totalEpisodes: 421,
    language: "English",
    rating: 4.4,
    subscribers: 178000,
    episodes: [
      {
        id: "7-1",
        title: "NBA Championship Predictions",
        description: "Expert panel discusses playoff contenders and potential dark horses.",
        duration: "67:30",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "7-2",
        title: "Interview: Soccer Legend Marcus Silva",
        description: "Exclusive conversation with the World Cup champion about his career and retirement.",
        duration: "72:15",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "7-3",
        title: "College Football Week 12 Recap",
        description: "Highlights, upsets, and playoff implications from the weekend's biggest games.",
        duration: "58:45",
        publishDate: "2024-11-19",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "8",
    title: "Science Simplified",
    publisher: "Science Education Network",
    description: "Making complex scientific concepts accessible and entertaining for everyone, from physics to biology.",
    image: "https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=400&h=400&fit=crop",
    category: "Science",
    totalEpisodes: 167,
    language: "English",
    rating: 4.9,
    subscribers: 143000,
    episodes: [
      {
        id: "8-1",
        title: "Black Holes Explained",
        description: "Everything you need to know about the most mysterious objects in the universe.",
        duration: "44:20",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "8-2",
        title: "CRISPR and Gene Editing",
        description: "The revolutionary technology that's changing medicine and agriculture.",
        duration: "48:30",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "8-3",
        title: "Climate Change: The Science",
        description: "Understanding the data and projections from leading climate scientists.",
        duration: "52:45",
        publishDate: "2024-11-08",
        audio: "https://example.com/episode3.mp3"
      },
      {
        id: "8-4",
        title: "The Human Brain Mysteries",
        description: "Neuroscientists discuss consciousness, memory, and cognition.",
        duration: "46:15",
        publishDate: "2024-11-01",
        audio: "https://example.com/episode4.mp3"
      }
    ]
  },
  {
    id: "9",
    title: "Creative Conversations",
    publisher: "Artists Collective Media",
    description: "Interviews with artists, musicians, writers, and creators about their craft and creative process.",
    image: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=400&h=400&fit=crop",
    category: "Arts",
    totalEpisodes: 203,
    language: "English",
    rating: 4.7,
    subscribers: 76000,
    episodes: [
      {
        id: "9-1",
        title: "Painting with Purpose: Interview with Luna Park",
        description: "Renowned visual artist discusses finding inspiration and developing your artistic voice.",
        duration: "54:30",
        publishDate: "2024-11-20",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "9-2",
        title: "The Writer's Journey",
        description: "Bestselling author shares tips on overcoming writer's block and finding your story.",
        duration: "49:45",
        publishDate: "2024-11-13",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "9-3",
        title: "Music Production Secrets",
        description: "Grammy-winning producer reveals studio techniques and creative processes.",
        duration: "61:20",
        publishDate: "2024-11-06",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "10",
    title: "Movie Buffs Review",
    publisher: "Cinema Network",
    description: "In-depth movie reviews, film analysis, and discussions about cinema past and present.",
    image: "https://images.unsplash.com/photo-1574267432644-f610a4ab60a4?w=400&h=400&fit=crop",
    category: "Film & TV",
    totalEpisodes: 298,
    language: "English",
    rating: 4.6,
    subscribers: 134000,
    episodes: [
      {
        id: "10-1",
        title: "New Releases: November 2024",
        description: "Our take on this month's biggest theatrical releases and streaming premieres.",
        duration: "56:15",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "10-2",
        title: "Classic Film Series: The Godfather",
        description: "Deep dive into Coppola's masterpiece 50 years later.",
        duration: "68:30",
        publishDate: "2024-11-16",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "10-3",
        title: "Interview: Director Amy Chen",
        description: "Rising filmmaker discusses her award-winning independent film.",
        duration: "51:45",
        publishDate: "2024-11-09",
        audio: "https://example.com/episode3.mp3"
      },
      {
        id: "10-4",
        title: "Best Movie Soundtracks Ever",
        description: "Celebrating the music that elevated great films to legendary status.",
        duration: "59:00",
        publishDate: "2024-11-02",
        audio: "https://example.com/episode4.mp3"
      }
    ]
  },
  {
    id: "11",
    title: "Investor's Edge",
    publisher: "Financial Times Podcasts",
    description: "Stock market analysis, investment strategies, and personal finance advice from Wall Street experts.",
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400&h=400&fit=crop",
    category: "Business",
    totalEpisodes: 412,
    language: "English",
    rating: 4.7,
    subscribers: 167000,
    episodes: [
      {
        id: "11-1",
        title: "Market Outlook 2025",
        description: "Top analysts predict next year's biggest investment opportunities.",
        duration: "49:30",
        publishDate: "2024-11-24",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "11-2",
        title: "Real Estate Investing 101",
        description: "Building wealth through property investment in today's market.",
        duration: "52:15",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "12",
    title: "Cooking with Passion",
    publisher: "Food Network Audio",
    description: "Celebrity chefs share recipes, cooking techniques, and culinary adventures from around the world.",
    image: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=400&h=400&fit=crop",
    category: "Food",
    totalEpisodes: 234,
    language: "English",
    rating: 4.8,
    subscribers: 118000,
    episodes: [
      {
        id: "12-1",
        title: "Mastering French Cuisine",
        description: "Chef Pierre Dubois teaches classic French cooking techniques.",
        duration: "41:20",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "12-2",
        title: "Street Food Around the World",
        description: "Exploring authentic street food culture across different countries.",
        duration: "38:45",
        publishDate: "2024-11-20",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "12-3",
        title: "Vegan Cooking Made Easy",
        description: "Delicious plant-based recipes for every meal of the day.",
        duration: "35:30",
        publishDate: "2024-11-17",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "13",
    title: "The Paranormal Files",
    publisher: "Mystery Media Co.",
    description: "Investigating unexplained phenomena, ghost stories, and supernatural mysteries.",
    image: "https://images.unsplash.com/photo-1509248961158-e54f6934749c?w=400&h=400&fit=crop",
    category: "Mystery",
    totalEpisodes: 187,
    language: "English",
    rating: 4.5,
    subscribers: 145000,
    episodes: [
      {
        id: "13-1",
        title: "Haunted Hotels of America",
        description: "Stay if you dare: the most haunted accommodations across the US.",
        duration: "53:40",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "13-2",
        title: "UFO Sightings in the Desert",
        description: "Examining credible reports of unexplained aerial phenomena.",
        duration: "47:25",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "14",
    title: "Parenting Real Talk",
    publisher: "Family Media Group",
    description: "Honest conversations about parenting challenges, tips, and triumphs from real parents.",
    image: "https://images.unsplash.com/photo-1476703993599-0035a21b17a9?w=400&h=400&fit=crop",
    category: "Family",
    totalEpisodes: 256,
    language: "English",
    rating: 4.6,
    subscribers: 94000,
    episodes: [
      {
        id: "14-1",
        title: "Navigating the Teenage Years",
        description: "Expert advice on communicating with and understanding your teen.",
        duration: "44:15",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "14-2",
        title: "Screen Time: Finding Balance",
        description: "Managing technology use in modern families.",
        duration: "39:50",
        publishDate: "2024-11-19",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "14-3",
        title: "Building Confidence in Kids",
        description: "Strategies to help children develop healthy self-esteem.",
        duration: "42:30",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "15",
    title: "Gaming Legends",
    publisher: "E-Sports Network",
    description: "Video game reviews, industry news, and interviews with top gaming personalities.",
    image: "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=400&h=400&fit=crop",
    category: "Gaming",
    totalEpisodes: 389,
    language: "English",
    rating: 4.7,
    subscribers: 203000,
    episodes: [
      {
        id: "15-1",
        title: "Game of the Year Predictions",
        description: "Our picks for 2024's best games across all platforms.",
        duration: "62:45",
        publishDate: "2024-11-24",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "15-2",
        title: "Retro Gaming Revival",
        description: "Why classic games are making a comeback.",
        duration: "48:20",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "16",
    title: "Travel Tales",
    publisher: "Wanderlust Productions",
    description: "Adventures, travel tips, and cultural insights from globetrotters and travel experts.",
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=400&h=400&fit=crop",
    category: "Travel",
    totalEpisodes: 198,
    language: "English",
    rating: 4.8,
    subscribers: 112000,
    episodes: [
      {
        id: "16-1",
        title: "Hidden Gems of Southeast Asia",
        description: "Off-the-beaten-path destinations worth exploring.",
        duration: "51:30",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "16-2",
        title: "Solo Travel Safety Tips",
        description: "Essential advice for traveling alone with confidence.",
        duration: "43:15",
        publishDate: "2024-11-14",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "16-3",
        title: "Budget Backpacking in Europe",
        description: "How to experience Europe without breaking the bank.",
        duration: "46:50",
        publishDate: "2024-11-07",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "17",
    title: "Philosophy for Life",
    publisher: "Wisdom Media",
    description: "Exploring philosophical ideas and how they apply to modern living and decision-making.",
    image: "https://images.unsplash.com/photo-1457369804613-52c61a468e7d?w=400&h=400&fit=crop",
    category: "Education",
    totalEpisodes: 142,
    language: "English",
    rating: 4.9,
    subscribers: 68000,
    episodes: [
      {
        id: "17-1",
        title: "Stoicism in the Digital Age",
        description: "Ancient wisdom for modern challenges and stress management.",
        duration: "48:25",
        publishDate: "2024-11-20",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "17-2",
        title: "Ethics of Artificial Intelligence",
        description: "Philosophical questions raised by advancing AI technology.",
        duration: "55:40",
        publishDate: "2024-11-13",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "18",
    title: "Music Matters",
    publisher: "Melody Network",
    description: "Deep dives into music history, artist interviews, and exploring genres from classical to contemporary.",
    image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=400&fit=crop",
    category: "Music",
    totalEpisodes: 312,
    language: "English",
    rating: 4.6,
    subscribers: 156000,
    episodes: [
      {
        id: "18-1",
        title: "The Evolution of Hip-Hop",
        description: "From the Bronx to worldwide phenomenon: hip-hop's journey.",
        duration: "58:30",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "18-2",
        title: "Behind the Album: Dark Side of the Moon",
        description: "The making of Pink Floyd's masterpiece.",
        duration: "64:15",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "18-3",
        title: "Interview: Rising Star Maya Johnson",
        description: "Exclusive chat with the year's breakout artist.",
        duration: "42:50",
        publishDate: "2024-11-08",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "19",
    title: "Relationship Matters",
    publisher: "Love & Life Network",
    description: "Expert advice on dating, relationships, marriage, and navigating love in the modern world.",
    image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=400&h=400&fit=crop",
    category: "Relationships",
    totalEpisodes: 224,
    language: "English",
    rating: 4.5,
    subscribers: 89000,
    episodes: [
      {
        id: "19-1",
        title: "Communication in Relationships",
        description: "Learning to truly listen and be heard by your partner.",
        duration: "46:20",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "19-2",
        title: "Modern Dating Dilemmas",
        description: "Navigating apps, expectations, and finding genuine connections.",
        duration: "41:35",
        publishDate: "2024-11-18",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "20",
    title: "Environmental Voices",
    publisher: "Green Planet Media",
    description: "Climate change, conservation efforts, and sustainable living practices for a healthier planet.",
    image: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=400&h=400&fit=crop",
    category: "Environment",
    totalEpisodes: 176,
    language: "English",
    rating: 4.8,
    subscribers: 102000,
    episodes: [
      {
        id: "20-1",
        title: "Ocean Conservation Efforts",
        description: "Innovative projects protecting marine ecosystems worldwide.",
        duration: "50:15",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "20-2",
        title: "Zero Waste Living Tips",
        description: "Practical steps to reduce your environmental footprint.",
        duration: "38:45",
        publishDate: "2024-11-14",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "20-3",
        title: "Renewable Energy Revolution",
        description: "How solar and wind power are transforming energy production.",
        duration: "45:30",
        publishDate: "2024-11-07",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "21",
    title: "Startup Stories",
    publisher: "Venture Media",
    description: "Founders share their entrepreneurial journeys, failures, and successes in building companies.",
    image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=400&h=400&fit=crop",
    category: "Business",
    totalEpisodes: 267,
    language: "English",
    rating: 4.7,
    subscribers: 134000,
    episodes: [
      {
        id: "21-1",
        title: "From Garage to IPO",
        description: "How one founder turned a side project into a billion-dollar company.",
        duration: "56:40",
        publishDate: "2024-11-24",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "21-2",
        title: "Failing Forward: Lessons Learned",
        description: "Entrepreneurs discuss their biggest failures and what they learned.",
        duration: "49:25",
        publishDate: "2024-11-20",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "22",
    title: "Mystery Noir",
    publisher: "Detective Stories Inc.",
    description: "Fictional detective stories and mystery dramas performed by professional voice actors.",
    image: "https://images.unsplash.com/photo-1526398977052-654221a252c1?w=400&h=400&fit=crop",
    category: "Fiction",
    totalEpisodes: 145,
    language: "English",
    rating: 4.6,
    subscribers: 87000,
    episodes: [
      {
        id: "22-1",
        title: "The Case of the Missing Heiress - Part 1",
        description: "Detective Morgan investigates a high-society disappearance.",
        duration: "34:20",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "22-2",
        title: "The Case of the Missing Heiress - Part 2",
        description: "The plot thickens as new suspects emerge.",
        duration: "36:15",
        publishDate: "2024-11-16",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "22-3",
        title: "Murder at the Manor",
        description: "A classic locked-room mystery with an unexpected twist.",
        duration: "41:30",
        publishDate: "2024-11-09",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "23",
    title: "Language Learning Lab",
    publisher: "Polyglot Productions",
    description: "Tips, techniques, and inspiration for learning new languages and understanding different cultures.",
    image: "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=400&h=400&fit=crop",
    category: "Education",
    totalEpisodes: 198,
    language: "English",
    rating: 4.5,
    subscribers: 76000,
    episodes: [
      {
        id: "23-1",
        title: "Mastering Spanish Pronunciation",
        description: "Expert guidance on perfecting your Spanish accent.",
        duration: "32:40",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "23-2",
        title: "Memory Techniques for Vocabulary",
        description: "Science-backed methods for remembering new words.",
        duration: "29:15",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "24",
    title: "Fashion Forward",
    publisher: "Style Network Podcasts",
    description: "Fashion trends, style advice, and industry insights from designers and fashion experts.",
    image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400&h=400&fit=crop",
    category: "Fashion",
    totalEpisodes: 213,
    language: "English",
    rating: 4.4,
    subscribers: 91000,
    episodes: [
      {
        id: "24-1",
        title: "Paris Fashion Week Highlights",
        description: "Runway reviews and emerging trends from the fashion capital.",
        duration: "47:30",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "24-2",
        title: "Sustainable Fashion Movement",
        description: "Eco-friendly brands changing the industry.",
        duration: "42:15",
        publishDate: "2024-11-19",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "24-3",
        title: "Building a Capsule Wardrobe",
        description: "Essential pieces for a versatile, minimalist closet.",
        duration: "38:50",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "25",
    title: "Pet Talk",
    publisher: "Animal Lovers Media",
    description: "Pet care advice, animal behavior insights, and heartwarming pet stories.",
    image: "https://images.unsplash.com/photo-1450778869180-41d0601e046e?w=400&h=400&fit=crop",
    category: "Pets",
    totalEpisodes: 167,
    language: "English",
    rating: 4.7,
    subscribers: 83000,
    episodes: [
      {
        id: "25-1",
        title: "Dog Training Fundamentals",
        description: "Professional trainer shares essential obedience techniques.",
        duration: "44:20",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "25-2",
        title: "Cat Health and Wellness",
        description: "Veterinarian discusses common feline health issues.",
        duration: "39:45",
        publishDate: "2024-11-14",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "26",
    title: "Psychology Insights",
    publisher: "Mind Science Network",
    description: "Understanding human behavior, mental health, and psychological research made accessible.",
    image: "https://images.unsplash.com/photo-1507413245164-6160d8298b31?w=400&h=400&fit=crop",
    category: "Psychology",
    totalEpisodes: 189,
    language: "English",
    rating: 4.8,
    subscribers: 126000,
    episodes: [
      {
        id: "26-1",
        title: "Understanding Cognitive Biases",
        description: "How our brains trick us and what we can do about it.",
        duration: "48:35",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "26-2",
        title: "The Science of Happiness",
        description: "Research-based strategies for increasing life satisfaction.",
        duration: "52:20",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "26-3",
        title: "Childhood Development Milestones",
        description: "What to expect as children grow and learn.",
        duration: "46:10",
        publishDate: "2024-11-08",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "27",
    title: "Cryptocurrency Corner",
    publisher: "Blockchain Media",
    description: "Bitcoin, blockchain technology, and the future of digital currencies explained.",
    image: "https://images.unsplash.com/photo-1518546305927-5a555bb7020d?w=400&h=400&fit=crop",
    category: "Technology",
    totalEpisodes: 234,
    language: "English",
    rating: 4.5,
    subscribers: 142000,
    episodes: [
      {
        id: "27-1",
        title: "Bitcoin ETF Approval Impact",
        description: "What institutional adoption means for crypto markets.",
        duration: "51:40",
        publishDate: "2024-11-24",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "27-2",
        title: "DeFi for Beginners",
        description: "Understanding decentralized finance and its potential.",
        duration: "46:25",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "28",
    title: "World Mythology",
    publisher: "Ancient Stories Collective",
    description: "Exploring myths, legends, and folklore from cultures around the globe.",
    image: "https://images.unsplash.com/photo-1533093818801-93f7bb5606b7?w=400&h=400&fit=crop",
    category: "History",
    totalEpisodes: 156,
    language: "English",
    rating: 4.7,
    subscribers: 94000,
    episodes: [
      {
        id: "28-1",
        title: "Norse Gods and Vikings",
        description: "Tales of Odin, Thor, and the Norse pantheon.",
        duration: "54:20",
        publishDate: "2024-11-20",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "28-2",
        title: "Egyptian Mythology: Gods of the Nile",
        description: "Ancient Egyptian deities and their stories.",
        duration: "49:35",
        publishDate: "2024-11-13",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "28-3",
        title: "Greek Heroes and Legends",
        description: "The epic tales of Hercules, Odysseus, and Perseus.",
        duration: "56:45",
        publishDate: "2024-11-06",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "29",
    title: "Career Catalyst",
    publisher: "Professional Growth Media",
    description: "Career advice, job search strategies, and professional development insights.",
    image: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400&h=400&fit=crop",
    category: "Career",
    totalEpisodes: 201,
    language: "English",
    rating: 4.6,
    subscribers: 107000,
    episodes: [
      {
        id: "29-1",
        title: "Negotiating Your Salary",
        description: "Expert tactics for getting paid what you're worth.",
        duration: "43:50",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "29-2",
        title: "Career Pivots: Changing Industries",
        description: "Successfully transitioning to a new career path.",
        duration: "47:15",
        publishDate: "2024-11-18",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "30",
    title: "Space Exploration",
    publisher: "Cosmos Broadcasting",
    description: "Latest discoveries in space science, astronomy, and the quest to explore the universe.",
    image: "https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?w=400&h=400&fit=crop",
    category: "Science",
    totalEpisodes: 178,
    language: "English",
    rating: 4.9,
    subscribers: 163000,
    episodes: [
      {
        id: "30-1",
        title: "Mars Colonization Plans",
        description: "Current missions and future plans for human settlement on Mars.",
        duration: "55:30",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "30-2",
        title: "James Webb Telescope Discoveries",
        description: "Stunning images and groundbreaking findings from deep space.",
        duration: "51:45",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "30-3",
        title: "Search for Extraterrestrial Life",
        description: "Are we alone? The scientific quest for life beyond Earth.",
        duration: "48:20",
        publishDate: "2024-11-08",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "31",
    title: "Horror Stories Tonight",
    publisher: "Dark Tales Productions",
    description: "Spine-chilling horror fiction and true scary stories guaranteed to keep you up at night.",
    image: "https://images.unsplash.com/photo-1509248961158-e54f6934749c?w=400&h=400&fit=crop",
    category: "Fiction",
    totalEpisodes: 223,
    language: "English",
    rating: 4.6,
    subscribers: 178000,
    episodes: [
      {
        id: "31-1",
        title: "The House on Hollow Hill",
        description: "A family moves into their dream home... with a dark secret.",
        duration: "37:25",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "31-2",
        title: "Urban Legends: The Hitchhiker",
        description: "A classic tale with a terrifying twist.",
        duration: "28:40",
        publishDate: "2024-11-19",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "32",
    title: "Home Improvement Hub",
    publisher: "DIY Network Audio",
    description: "DIY projects, home renovation tips, and interior design inspiration for homeowners.",
    image: "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=400&h=400&fit=crop",
    category: "Home & Garden",
    totalEpisodes: 245,
    language: "English",
    rating: 4.5,
    subscribers: 88000,
    episodes: [
      {
        id: "32-1",
        title: "Kitchen Renovation on a Budget",
        description: "Transform your kitchen without spending a fortune.",
        duration: "44:30",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "32-2",
        title: "Gardening for Beginners",
        description: "Starting your first vegetable garden this spring.",
        duration: "39:15",
        publishDate: "2024-11-17",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "32-3",
        title: "Smart Home Technology",
        description: "Automating your home with the latest tech gadgets.",
        duration: "41:50",
        publishDate: "2024-11-13",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "33",
    title: "Wine & Spirits Guide",
    publisher: "Sommelier Network",
    description: "Wine tasting, spirit appreciation, and pairing recommendations from certified sommeliers.",
    image: "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=400&h=400&fit=crop",
    category: "Food",
    totalEpisodes: 167,
    language: "English",
    rating: 4.7,
    subscribers: 72000,
    episodes: [
      {
        id: "33-1",
        title: "French Wine Regions Explored",
        description: "A journey through Bordeaux, Burgundy, and beyond.",
        duration: "48:20",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "33-2",
        title: "Craft Cocktail Masterclass",
        description: "Mixology techniques for the home bartender.",
        duration: "36:45",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "34",
    title: "Political Pulse",
    publisher: "Current Affairs Network",
    description: "Non-partisan analysis of political events, policy discussions, and election coverage.",
    image: "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=400&h=400&fit=crop",
    category: "News & Politics",
    totalEpisodes: 412,
    language: "English",
    rating: 4.4,
    subscribers: 156000,
    episodes: [
      {
        id: "34-1",
        title: "2024 Election Analysis",
        description: "Breaking down the key issues and candidates.",
        duration: "59:30",
        publishDate: "2024-11-24",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "34-2",
        title: "Healthcare Policy Debate",
        description: "Examining proposed reforms and their implications.",
        duration: "52:15",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "35",
    title: "Meditation & Mindfulness",
    publisher: "Inner Peace Productions",
    description: "Guided meditations, breathing exercises, and mindfulness practices for daily calm.",
    image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=400&h=400&fit=crop",
    category: "Health & Fitness",
    totalEpisodes: 289,
    language: "English",
    rating: 4.9,
    subscribers: 198000,
    episodes: [
      {
        id: "35-1",
        title: "Morning Energy Meditation",
        description: "Start your day with focus and positive energy.",
        duration: "15:30",
        publishDate: "2024-11-24",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "35-2",
        title: "Sleep Relaxation Session",
        description: "Drift into peaceful sleep with this calming meditation.",
        duration: "25:45",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "35-3",
        title: "Stress Relief Breathing",
        description: "Quick breathing techniques for anxiety and stress.",
        duration: "12:20",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "36",
    title: "Book Club Discussion",
    publisher: "Literary Review Podcasts",
    description: "Monthly book discussions, author interviews, and reading recommendations for book lovers.",
    image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=400&h=400&fit=crop",
    category: "Books",
    totalEpisodes: 156,
    language: "English",
    rating: 4.8,
    subscribers: 91000,
    episodes: [
      {
        id: "36-1",
        title: "November Pick: The Midnight Library",
        description: "Deep dive discussion of Matt Haig's bestseller.",
        duration: "53:40",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "36-2",
        title: "Interview: Author James Patterson",
        description: "Exclusive conversation about his latest thriller.",
        duration: "47:25",
        publishDate: "2024-11-16",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "37",
    title: "Automotive Enthusiast",
    publisher: "Gearhead Media",
    description: "Car reviews, racing news, and automotive industry insights for vehicle enthusiasts.",
    image: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=400&h=400&fit=crop",
    category: "Automotive",
    totalEpisodes: 298,
    language: "English",
    rating: 4.6,
    subscribers: 134000,
    episodes: [
      {
        id: "37-1",
        title: "2025 Electric Vehicle Lineup",
        description: "Reviewing the hottest new EVs hitting the market.",
        duration: "56:30",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "37-2",
        title: "Formula 1 Season Recap",
        description: "Analyzing the most dramatic F1 season in years.",
        duration: "62:45",
        publishDate: "2024-11-20",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "37-3",
        title: "Classic Car Restoration Tips",
        description: "Expert advice on bringing vintage vehicles back to life.",
        duration: "48:15",
        publishDate: "2024-11-17",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "38",
    title: "Photography Masterclass",
    publisher: "Visual Arts Network",
    description: "Photography techniques, camera gear reviews, and creative inspiration for photographers.",
    image: "https://images.unsplash.com/photo-1452587925148-ce544e77e70d?w=400&h=400&fit=crop",
    category: "Photography",
    totalEpisodes: 187,
    language: "English",
    rating: 4.7,
    subscribers: 84000,
    episodes: [
      {
        id: "38-1",
        title: "Mastering Portrait Lighting",
        description: "Professional lighting setups for stunning portraits.",
        duration: "44:20",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "38-2",
        title: "Landscape Photography Secrets",
        description: "Capturing breathtaking outdoor scenes.",
        duration: "51:35",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "39",
    title: "Legal Insights",
    publisher: "Law & Order Podcasts",
    description: "Legal issues explained, famous court cases analyzed, and law career advice.",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400&h=400&fit=crop",
    category: "Law",
    totalEpisodes: 234,
    language: "English",
    rating: 4.5,
    subscribers: 78000,
    episodes: [
      {
        id: "39-1",
        title: "Landmark Supreme Court Cases",
        description: "Decisions that shaped American law and society.",
        duration: "58:40",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "39-2",
        title: "Understanding Copyright Law",
        description: "Protecting creative work in the digital age.",
        duration: "46:25",
        publishDate: "2024-11-14",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "39-3",
        title: "Criminal Justice Reform",
        description: "Examining proposed changes to the legal system.",
        duration: "52:30",
        publishDate: "2024-11-07",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "40",
    title: "Dance Culture",
    publisher: "Movement Arts Media",
    description: "Exploring dance styles, choreography, and the art of movement from around the world.",
    image: "https://images.unsplash.com/photo-1508700929628-666bc8bd84ea?w=400&h=400&fit=crop",
    category: "Dance",
    totalEpisodes: 145,
    language: "English",
    rating: 4.6,
    subscribers: 67000,
    episodes: [
      {
        id: "40-1",
        title: "Ballet: Grace and Technique",
        description: "Professional ballerina shares training insights.",
        duration: "42:30",
        publishDate: "2024-11-20",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "40-2",
        title: "Hip-Hop Dance Evolution",
        description: "From street corners to worldwide phenomenon.",
        duration: "48:15",
        publishDate: "2024-11-13",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "41",
    title: "Economics Explained",
    publisher: "Market Watch Audio",
    description: "Making economic concepts accessible with real-world examples and expert analysis.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=400&fit=crop",
    category: "Business",
    totalEpisodes: 201,
    language: "English",
    rating: 4.7,
    subscribers: 112000,
    episodes: [
      {
        id: "41-1",
        title: "Understanding Inflation",
        description: "Why prices rise and what it means for your wallet.",
        duration: "47:30",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "41-2",
        title: "Global Trade Wars",
        description: "How tariffs and trade policies affect economies worldwide.",
        duration: "53:45",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "41-3",
        title: "The Gig Economy Explained",
        description: "Freelancing, side hustles, and the future of work.",
        duration: "44:20",
        publishDate: "2024-11-08",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "42",
    title: "Spirituality & Faith",
    publisher: "Sacred Stories Network",
    description: "Exploring different spiritual traditions, faith practices, and personal growth journeys.",
    image: "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=400&h=400&fit=crop",
    category: "Religion",
    totalEpisodes: 178,
    language: "English",
    rating: 4.8,
    subscribers: 96000,
    episodes: [
      {
        id: "42-1",
        title: "World Religions Comparison",
        description: "Understanding common themes across different faiths.",
        duration: "51:25",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "42-2",
        title: "Meditation in Different Traditions",
        description: "How various religions practice contemplative prayer.",
        duration: "45:30",
        publishDate: "2024-11-14",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "43",
    title: "Astronomy Tonight",
    publisher: "Stargazer Productions",
    description: "What's happening in the night sky, celestial events, and amateur astronomy tips.",
    image: "https://images.unsplash.com/photo-1462332420958-a05d1e002413?w=400&h=400&fit=crop",
    category: "Science",
    totalEpisodes: 267,
    language: "English",
    rating: 4.7,
    subscribers: 108000,
    episodes: [
      {
        id: "43-1",
        title: "Meteor Shower Viewing Guide",
        description: "When and where to see this month's celestial show.",
        duration: "32:40",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "43-2",
        title: "Choosing Your First Telescope",
        description: "Beginner's guide to stargazing equipment.",
        duration: "38:25",
        publishDate: "2024-11-18",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "43-3",
        title: "Understanding Constellations",
        description: "Stories behind the star patterns we see.",
        duration: "41:50",
        publishDate: "2024-11-13",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "44",
    title: "Animation Nation",
    publisher: "Cartoon Network Podcasts",
    description: "Celebrating animated films and series with reviews, creator interviews, and industry news.",
    image: "https://images.unsplash.com/photo-1578632767115-351597cf2477?w=400&h=400&fit=crop",
    category: "Film & TV",
    totalEpisodes: 189,
    language: "English",
    rating: 4.6,
    subscribers: 124000,
    episodes: [
      {
        id: "44-1",
        title: "Pixar's Greatest Hits",
        description: "Ranking the studio's most beloved films.",
        duration: "62:30",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "44-2",
        title: "Anime Recommendations 2024",
        description: "Must-watch series and films from Japan.",
        duration: "55:15",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "45",
    title: "Social Media Strategies",
    publisher: "Digital Marketing Hub",
    description: "Tips for growing your online presence, content creation, and influencer insights.",
    image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=400&h=400&fit=crop",
    category: "Marketing",
    totalEpisodes: 312,
    language: "English",
    rating: 4.5,
    subscribers: 147000,
    episodes: [
      {
        id: "45-1",
        title: "TikTok Algorithm Secrets",
        description: "How to get your content seen by millions.",
        duration: "43:20",
        publishDate: "2024-11-24",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "45-2",
        title: "Building Your Personal Brand",
        description: "Standing out in a crowded digital landscape.",
        duration: "48:35",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "45-3",
        title: "Instagram Growth Strategies",
        description: "Organic methods to increase followers and engagement.",
        duration: "41:50",
        publishDate: "2024-11-18",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "46",
    title: "Theater & Broadway",
    publisher: "Stage Productions Network",
    description: "Broadway reviews, musical theater history, and interviews with stage performers.",
    image: "https://images.unsplash.com/photo-1503095396549-807759245b35?w=400&h=400&fit=crop",
    category: "Theater",
    totalEpisodes: 167,
    language: "English",
    rating: 4.7,
    subscribers: 73000,
    episodes: [
      {
        id: "46-1",
        title: "Hamilton: Behind the Phenomenon",
        description: "How Lin-Manuel Miranda revolutionized musical theater.",
        duration: "58:40",
        publishDate: "2024-11-20",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "46-2",
        title: "Broadway Season Preview",
        description: "Upcoming shows to watch this year.",
        duration: "46:25",
        publishDate: "2024-11-13",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "47",
    title: "Architecture & Design",
    publisher: "Blueprint Media",
    description: "Exploring iconic buildings, design principles, and the future of architecture.",
    image: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=400&h=400&fit=crop",
    category: "Architecture",
    totalEpisodes: 143,
    language: "English",
    rating: 4.6,
    subscribers: 81000,
    episodes: [
      {
        id: "47-1",
        title: "Frank Lloyd Wright's Legacy",
        description: "Examining the master architect's revolutionary designs.",
        duration: "52:30",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "47-2",
        title: "Sustainable Building Design",
        description: "Eco-friendly architecture for the future.",
        duration: "47:15",
        publishDate: "2024-11-14",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "47-3",
        title: "Urban Planning Challenges",
        description: "Designing cities for growing populations.",
        duration: "49:45",
        publishDate: "2024-11-07",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "48",
    title: "Adventure Seekers",
    publisher: "Outdoor Life Network",
    description: "Extreme sports, outdoor adventures, and survival stories from around the globe.",
    image: "https://images.unsplash.com/photo-1551632811-561732d1e306?w=400&h=400&fit=crop",
    category: "Adventure",
    totalEpisodes: 223,
    language: "English",
    rating: 4.8,
    subscribers: 156000,
    episodes: [
      {
        id: "48-1",
        title: "Climbing Mount Everest",
        description: "Mountaineer shares their journey to the world's highest peak.",
        duration: "64:30",
        publishDate: "2024-11-23",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "48-2",
        title: "Surfing Big Waves",
        description: "Professional surfers discuss conquering massive swells.",
        duration: "51:45",
        publishDate: "2024-11-19",
        audio: "https://example.com/episode2.mp3"
      }
    ]
  },
  {
    id: "49",
    title: "Yoga & Wellness",
    publisher: "Zen Living Productions",
    description: "Yoga practices, holistic health approaches, and wellness lifestyle tips.",
    image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=400&h=400&fit=crop",
    category: "Health & Fitness",
    totalEpisodes: 278,
    language: "English",
    rating: 4.8,
    subscribers: 134000,
    episodes: [
      {
        id: "49-1",
        title: "Beginner Yoga Fundamentals",
        description: "Essential poses and breathing techniques for newcomers.",
        duration: "36:20",
        publishDate: "2024-11-24",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "49-2",
        title: "Ayurvedic Medicine Basics",
        description: "Ancient healing wisdom for modern wellness.",
        duration: "42:45",
        publishDate: "2024-11-21",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "49-3",
        title: "Advanced Vinyasa Flow",
        description: "Challenging sequences for experienced practitioners.",
        duration: "44:30",
        publishDate: "2024-11-18",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  },
  {
    id: "50",
    title: "Documentary Diaries",
    publisher: "Reality Productions",
    description: "Discussing powerful documentaries, true stories, and the art of non-fiction filmmaking.",
    image: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=400&h=400&fit=crop",
    category: "Film & TV",
    totalEpisodes: 156,
    language: "English",
    rating: 4.7,
    subscribers: 98000,
    episodes: [
      {
        id: "50-1",
        title: "Nature Documentaries that Changed Perceptions",
        description: "How wildlife films influence conservation efforts.",
        duration: "54:20",
        publishDate: "2024-11-22",
        audio: "https://example.com/episode1.mp3"
      },
      {
        id: "50-2",
        title: "True Crime Docs: Ethics and Impact",
        description: "The responsibility of telling real-life crime stories.",
        duration: "48:35",
        publishDate: "2024-11-15",
        audio: "https://example.com/episode2.mp3"
      },
      {
        id: "50-3",
        title: "Interview: Oscar-Winning Director",
        description: "Discussing the craft of documentary filmmaking.",
        duration: "61:25",
        publishDate: "2024-11-08",
        audio: "https://example.com/episode3.mp3"
      }
    ]
  }
];

export const categories = [
  { id: "1", name: "Technology", image: "/images/categories/technology.jpg" },
  { id: "2", name: "Business", image: "/images/categories/business.jpg" },
  { id: "3", name: "True Crime", image: "/images/categories/crime.jpg" },
  { id: "4", name: "Health & Fitness", image: "/images/categories/health.jpg" },
  { id: "5", name: "Comedy", image: "/images/categories/comedy.jpg" },
  { id: "6", name: "History", image: "/images/categories/history.jpg" },
  { id: "7", name: "Sports", image: "/images/categories/sports.jpg" },
  { id: "8", name: "Science", image: "/images/categories/science.jpg" },
  { id: "9", name: "Arts", image: "/images/categories/arts.jpg" },
  { id: "10", name: "Film & TV", image: "/images/categories/film.jpg" }
];

export default podcasts;
